// extracted by mini-css-extract-plugin
export var cardIcon = "_1a-5";
export var cardIconUnframed = "_1a-9";
export var checkboxCard = "_1a-0";
export var checkboxCardSelected = "_1a-4";
export var disabled = "_1a-2";
export var interactive = "_1a-1";
export var outerBorder = "_1a-3";
export var spacerMedium = "_1a-8";
export var spacerSmall = "_1a-7";
export var spacerXsmall = "_1a-6";